import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import DynamicLander from "../components/Lawsuits/DynamicLander";

const DynamicTemplatePage = () => {
  const { slug } = useParams();

  const [template, setTemplate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetchTemplate();
  }, [slug]);

  const fetchTemplate = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/dynamic-templates/slug/${slug}`
      );

    // const response = await fetch(
    // `https://6g63rxgz-8080.inc1.devtunnels.ms/api/dynamic-templates/slug/${slug}`
    // );

      if (!response.ok) {
        setNotFound(true);
        return;
      }

      const data = await response.json();

      setTemplate(data.data);
    } catch (error) {
      console.error("Error fetching template:", error);
      setNotFound(true);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="w-full min-h-screen flex items-center justify-center text-xl font-semibold">
        Loading...
      </div>
    );
  }

  if (notFound || !template) {
    return (
   <div className="w-full min-h-screen flex items-center justify-center px-6 bg-white">
  <div className="max-w-lg text-center">
    <div
      className="text-5xl font-semibold text-[#1F2937]"
      style={{ fontFamily: "Quicksand, sans-serif" }}
    >
      404
    </div>

    <h1
      className="mt-4 text-2xl font-semibold text-[#111827]"
      style={{ fontFamily: "Quicksand, sans-serif" }}
    >
      Page Not Found
    </h1>

    <p
      className="mt-3 text-base text-[#6B7280] leading-relaxed"
      style={{ fontFamily: "Quicksand, sans-serif" }}
    >
      The page you’re looking for may have been moved, removed, or is temporarily unavailable.
    </p>

    <a
      href="/"
      className="inline-flex items-center justify-center mt-8 px-6 py-3 border border-[#D1D5DB] rounded-md text-sm font-medium text-[#111827] hover:bg-[#F9FAFB] transition-colors"
      style={{ fontFamily: "Quicksand, sans-serif" }}
    >
      Return Home
    </a>
  </div>
</div>
    );
  }

  return (
    <DynamicLander
      templateData={template.template_data}
    />
  );
};

export default DynamicTemplatePage;